<mat-dialog-content class="container">
    <div class="flex column">
        <button class="align-end" mat-icon-button (click)="dismiss()"> <mat-icon>close</mat-icon> </button>
        <div class="flex space-between">
            <h4>{{data.title | translateWithKeys:(areThereTitleParams ? data?.titleParams : {}) }}</h4>
        </div>
        <p class="body1 mt-14">{{data.description | translateWithKeys }}</p>
    </div>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <div class="flex row end gap-12">
        @if (data.dismissBtnText?.length) {
            <button mat-stroked-button [disabled]="data?.dismissBtnDisable" class="button" (click)="decline()">
                {{ (data.dismissBtnText ?? 'general.dismiss') | translateWithKeys}}
            </button>
        }
        @if (data.acceptBtnText?.length) {
            <button mat-stroked-button [disabled]="data?.acceptBtnDisable" class="button" [ngClass]="data.btnColor" (click)="accept()">
                {{ (data.acceptBtnText ?? 'general.continue') | translateWithKeys}}
            </button>
        }
    </div>
</mat-dialog-actions>
